<template>
  <div>
    <b-form @submit.prevent="onSubmit" v-if="!resetDone">
      <b-form-group class="required" label="Email">
        <b-form-input
          v-model="username"
          autocomplete="off"
          :state="$v.username.$error? false : null"
          @input="$v.username.$reset()"
        />
      </b-form-group>

      <b-form-group class="required" label="Hasło">
        <b-input-group>
          <b-form-input
            v-model="password"
            autocomplete="off"
            type="password"
            :state="$v.password.$error? false : null"
            @input="$v.password.$reset()"
          />
        </b-input-group>
      </b-form-group>

      <b-form-group class="required" label="Powtórz hasło">
        <b-input-group>
          <b-form-input
            v-model="confirmPassword"
            autocomplete="off"
            type="password"
            :state="$v.confirmPassword.$error? false : null"
            @input="$v.confirmPassword.$reset()"
          />
        </b-input-group>
      </b-form-group>

      <b-form-group class="text-right">
        <b-button type="submit" variant="primary" block :disabled="loading">
          <span v-show="!loading">Zmień hasło</span>
          <span v-show="loading">
            <b-spinner small label="Loading..."></b-spinner>
          </span>
        </b-button>
        <b-button variant="link" @click="goto('/public/login')">Zaloguj się</b-button>
      </b-form-group>
    </b-form>
    <success v-else />
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, email, sameAs } from "vuelidate/lib/validators";
import success from "./ResetPasswordSuccess";

export default {
  data() {
    return {
      username: null,
      password: null,
      confirmPassword: null,
      token: null,
      loading: false,
      resetDone: false
    };
  },
  components: {
    success
  },
  validations: {
    username: {
      required,
      email
    },
    password: {
      required
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs("password")
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.loading = true;
        axios
          .post("/auth/resetPassword", {
            username: this.username,
            password: this.password,
            confirmPassword: this.confirmPassword,
            token: this.$route.query.token
          })
          .then(() => {
            this.resetDone = true;
            eventBus.$emit("notify-success", "Hasło zostało zmienione");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.loading = false));
      }
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  &.btn-link {
    font-size: 0.75rem;
    text-decoration: none;
  }
}
</style>